// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"boolButton_wrapper__2caMA","labelWrapper":"boolButton_labelWrapper__A_gXx","button":"boolButton_button__Vb8J7","active":"boolButton_active__2cjMy"};